import type { PolygonOpenContour } from '../polygon-open-contour';
import type { PointArray } from '../types/contour-definition-array-type';

import { getClosestPointIdx } from './getClosestPointIdx';
import { interpolateGridPoints2D } from './interpolatePolygonToGrid';
import { snapPolyLineToSubPixelGrid } from './snapPolyLineToSubPixelGrid';

export function createLaxTransmuralityPolygons(
  endoContour: PolygonOpenContour,
  epiContour: PolygonOpenContour,
): PointArray[] {
  const endo = endoContour.getPolygon();
  const epi = epiContour.getPolygon();

  // centroid

  // get transmurality
  const transmurality = [];
  const endoClosestPoints = [];
  for (let i = 0; i < epi.length; i++) {
    const idxEndo = getClosestPointIdx(epi[i], endo);
    endoClosestPoints.push(endo[idxEndo]);
    transmurality.push({
      x: epi[i].x - endo[idxEndo].x,
      y: epi[i].y - endo[idxEndo].y,
    });
  }

  // get centerlines in 5% steps
  const centerlines = [] as PointArray[];
  for (let j = 0; j <= 100; j += 5) {
    let centerline = [] as PointArray;
    for (let i = 0; i < endoClosestPoints.length; i++) {
      centerline.push({
        x: endoClosestPoints[i].x + transmurality[i].x * j * 0.01,
        y: endoClosestPoints[i].y + transmurality[i].y * j * 0.01,
      });
    }
    centerline = interpolateGridPoints2D(centerline, 1);
    centerline = snapPolyLineToSubPixelGrid(centerline, false);
    centerlines.push(centerline);
  }
  return centerlines;
}
